export const SORT_BY_TIME = 1;
export const SORT_BY_LEAGUE = 2;



// WEBPACK FOOTER //
// ./js/sport-betting/components/Timetable/SortMode.js